import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const REGEX_THOUSANDS_DELIMITER = /.{1,3}(?=(?:.{3})+(?!.))|.{1,3}$/g;
const SYMBOL_AFTER_NUMBER = ['€'];
const CURRENCY_TO_SYMBOL = {
  ARS: 'ARS$',
  AUD: 'AUD$',
  BRL: 'R$',
  CAD: 'CAD$',
  CHF: 'CHF$',
  CLP: 'CLP$',
  COP: 'COP$',
  EUR: '€',
  GBP: '£',
  JPY: '\u00A5',
  KRW: 'KRW$',
  MXN: 'MX$',
  NGN: '\u20A6',
  PEN: 'S/.',
  TWD: 'TWD$',
  UYU: 'UYU$',
  USD: 'US$'
};

class Currency {
  currencyPriceDelimiter(currencyName) {
    let centsDelimiter = '.';
    let thousandsDelimiter = ',';

    if (currencyName === 'BRL') {
      centsDelimiter = ',';
      thousandsDelimiter = '.';
    }

    return { centsDelimiter, thousandsDelimiter };
  }

  formatNumber(value, delimiter) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    value = value.toFixed(2);

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    let valueWithoutCents = value.slice(0, -3);
    let cents = value.slice(valueWithoutCents.length);

    valueWithoutCents = valueWithoutCents
      .match(REGEX_THOUSANDS_DELIMITER)
      .join(delimiter.thousandsDelimiter);

    cents = cents.replace('.', delimiter.centsDelimiter);
    return valueWithoutCents + cents;
  }

  formatCurrency = (value, currencyName) => {
    const delimiter = this.currencyPriceDelimiter(currencyName);

    return this.formatNumber(value, delimiter);
  };

  formatCurrencySymbol = (value, currencyName) => {
    const currencySymbol = this.symbol(currencyName);
    const formatted = this.formatCurrency(value, currencyName);

    let valueWithCurrency = '';

    if (SYMBOL_AFTER_NUMBER.includes(currencySymbol)) {
      valueWithCurrency = `${formatted} ${currencySymbol}`;
    } else {
      valueWithCurrency = `${currencySymbol} ${formatted}`;
    }

    return valueWithCurrency;
  };

  symbol = (currencyName) => CURRENCY_TO_SYMBOL[currencyName];

  currencyStringToNumber = (string) =>
    string ? parseFloat(string.replace(/\./g, '').replace(',', '.')) : null;

  numberToCurrencyString = (number) =>
    number
      ? // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        String(number.toFixed(2)).replace(/\./g, ',')
      : null;

  currencyMaskFn = createNumberMask({
    allowDecimal: true,
    decimalSymbol: ',',
    integerLimit: 10,
    prefix: '',
    suffix: '',
    thousandsSeparatorSymbol: '.'
  });
}

export { CURRENCY_TO_SYMBOL, SYMBOL_AFTER_NUMBER };

export default new Currency();
